/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsFeaturedCollection = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

      let $sliderEl = $section.find('[data-slider]');
      this.$progessBar = $section.find('[data-bar]')

      if (this.collection_style == 'slider') {
        this.createSlider($sliderEl);
      }
    },
    createSlider: function ($sliderEl) {
      const slider = $sliderEl.flickity({
        draggable: true,
        cellAlign: 'center',
        wrapAround: false,
        pageDots: false,
        contain: true,
        prevNextButtons: true,
        initialIndex: 3
      });
      slider.on('settle.flickity', function () {
        slider.flickity('resize');
      });

      slider.on('scroll.flickity', function (_,progress) {
        progress = Math.max(0, Math.min(1, progress));
        this.$progessBar.width(progress * 100 + '%');
      }.bind(this));

    },
    unload: function ($section) {
      let $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
    }
  }

  /******/
})()
  ;